import { Entity, FetchError, FetchResponse, Message, MessageType, Method, Severity } from '../shared/types'

export type QueryParams = {
  [key: string]: string | number | boolean | undefined | null
}

const fetchData = (
  restPath: string,
  version: string,
  fetchHeaders: Headers,
  entity: Entity,
  method: Method,
  id?: string,
  data?: any,
  setData?: (data: FetchResponse) => void,
  setMessage?: (message: Message) => void,
) => {
  let eventType: MessageType = MessageType.load
  switch (method) {
    case Method.PUT:
      eventType = MessageType.update
      break
    case Method.DELETE:
      eventType = MessageType.delete
      break
    case Method.POST:
      eventType = MessageType.create
      break
  }
  fetch(`${restPath}/api/${version}/${entity}${id ? `/${id}` : ''}`, {
    credentials: 'include',
    method: method,
    headers: fetchHeaders,
    body: JSON.stringify(data),
  }).then(async res => {
    if (res.status === 403) {
      window.location.href = '/login'
    }
    let message = 'Etwas ist schief gegangen!'
    if (res.status < 400) {
      switch (method) {
        case Method.PUT:
          message = 'Daten wurden gespeichert'
          break
        case Method.POST:
          message = 'Daten wurden erstellt'
          break
        case Method.GET:
          message = 'Daten wurden geladen'
          break
        case Method.DELETE:
          message = 'Daten wurden gelöscht'
          break
      }
      try {
        const response: FetchResponse = await res.json()
        response && setData && setData(response)
        setMessage && setMessage({ message: message, severity: Severity.success, eventType })
      } catch (err) {
        console.log(err)
      }
    } else {
      try {
        const response: FetchError = await res.json()
        message = response.message
        setMessage && setMessage({ message: message, severity: Severity.error, eventType })
      } catch (err) {
        console.log(err)
      }
    }
  })
}
export default fetchData
